export const container = `text-xs font-normal text-gray-400 m-0`;
